var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "flip-a",
    d: "M32,0 C14.326888,0 0,14.326888 0,32 C0,49.673112 14.326888,64 32,64 C49.673112,64 64,49.673112 64,32 C64,14.326888 49.673112,0 32,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "flip-b",
    width: "106.2%",
    height: "106.2%",
    x: "-3.1%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "flip-c",
    d: "M36.8984375,14 C38.4609375,14 39.859375,14.96875 40.40625,16.4296875 L41.375,19 L48.25,19 C50.3203125,19 52,20.6796875 52,22.75 L52,45.25 C52,47.3203125 50.3203125,49 48.25,49 L15.75,49 C13.6796875,49 12,47.3203125 12,45.25 L12,22.75 C12,20.6796875 13.6796875,19 15.75,19 L22.625,19 L23.5859375,16.4296875 C24.1328125,14.96875 25.53125,14 27.09375,14 L36.8984375,14 Z M22.8409027,29.3102787 L19.6590906,33.4528037 C19.5556817,33.5879366 19.5,33.7510282 19.5,33.9187795 C19.5,34.3474772 19.8547721,34.6954058 20.295453,34.6954058 L21.88795,34.6954058 C21.8863591,36.3092354 22.3143128,37.9152987 23.1638567,39.3551639 C24.4715815,41.5654425 26.5238503,43.0860769 28.9770274,43.701165 C31.3952046,44.3053803 34.0249724,43.9931765 36.2045137,42.7661069 C36.9649668,42.3374091 37.2258754,41.3883717 36.7867853,40.6443637 C36.3461043,39.9019089 35.3740607,39.6456222 34.6136076,40.0758732 C33.1706558,40.8882243 31.3967955,41.0994667 29.7677077,40.6909612 C28.1433926,40.2855623 26.799077,39.2883741 25.9208969,37.8019112 C25.3529434,36.8435543 25.0681712,35.7718099 25.0697621,34.6954058 L26.6590773,34.6954058 C26.8308951,34.6954058 26.9979403,34.641042 27.1347582,34.5400805 C27.4879393,34.2822406 27.5595301,33.7960725 27.2954397,33.4528037 L24.1136276,29.3102787 C24.0674913,29.2528084 24.0149914,29.1999978 23.9529461,29.1549534 C23.6029467,28.8986667 23.1034022,28.9670099 22.8409027,29.3102787 Z M26.9303182,24.431176 C26.2001788,24.8621888 25.9501937,25.816351 26.3709004,26.5643768 C26.7931313,27.3108409 27.7244782,27.5669499 28.4546176,27.1359371 C29.8920319,26.2848431 31.5230322,26.0755833 33.0732446,26.5097193 C34.6249813,26.9438554 35.972462,27.9839079 36.7833892,29.4221786 C37.3123211,30.3591628 37.5836464,31.3960921 37.6004137,32.4408295 L35.9739863,32.4408295 C35.8078376,32.4408295 35.6477862,32.4954869 35.5166965,32.5969935 C35.1798263,32.8562258 35.1112328,33.3450192 35.3627422,33.6901418 L38.4113409,37.8550366 C38.4570699,37.914379 38.5073718,37.9659131 38.5652952,38.009639 C38.9021653,38.2688713 39.379271,38.2001591 39.6323047,37.8550366 L42.6809034,33.6901418 C42.7784586,33.554279 42.8333333,33.3903068 42.8333333,33.2216496 C42.8333333,32.7906369 42.4918903,32.4408295 42.0711837,32.4408295 L40.6490124,32.4408295 C40.6322451,30.8557645 40.2237328,29.2800694 39.4219514,27.8605383 C38.2040362,25.699228 36.1919611,24.1453958 33.8765504,23.4957534 C31.5458967,22.8445494 29.0765317,23.1615624 26.9303182,24.431176 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#26436F",
    xlinkHref: "#flip-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#flip-b)",
    xlinkHref: "#flip-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#flip-c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSwitch);
export default __webpack_public_path__ + "static/media/camera_switch.14c9b2e18f857c5e0943951f3fdb1f97.svg";
export { ForwardRef as ReactComponent };